import { type Constructor } from '../types';
import { type fabric } from 'fabric';

interface BackgroundBehaviors {
  renderBackgroundGrid(ctx: CanvasRenderingContext2D): void;
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
function BackgroundBehaviors(Base: Constructor<fabric.Canvas>): any {
  return class extends Base {
    // There are 3 secondary grid lines between each  primary. The
    // basis is the spacing between the gridlines at 100% zoom.
    BG_GRID_PRIMARY_BASIS = 100;
    BG_GRID_SECONDARY_BASIS = this.BG_GRID_PRIMARY_BASIS / 4;
    BG_GRID_PRIMARY_COLOR = '#DFDFDF';
    BG_GRID_PRIMARY_WIDTH = 1;
    BG_GRID_SECONDARY_COLOR = '#E5E5E5';
    BG_GRID_SECONDARY_WIDTH = 0.7;

    renderBackgroundGrid(ctx: CanvasRenderingContext2D) {
      const zoom = this.getZoom();

      const zoomStep = 2 ** Math.floor(Math.log2(zoom / 0.9));
      const factor = this.BG_GRID_PRIMARY_BASIS / this.BG_GRID_SECONDARY_BASIS;
      const primaryGrid = this.BG_GRID_PRIMARY_BASIS / zoomStep;
      const secondaryGrid = primaryGrid / factor;

      const vpt = this.vptCoords!;
      const minX = primaryGrid * Math.floor(vpt.tl.x / primaryGrid);
      const maxX = primaryGrid * Math.ceil(vpt.br.x / primaryGrid);
      const minY = primaryGrid * Math.floor(vpt.tl.y / primaryGrid);
      const maxY = primaryGrid * Math.ceil(vpt.bl.y / primaryGrid);

      ctx.save();
      ctx.globalAlpha = 1;

      const primary = {
        spacing: primaryGrid,
        width: this.BG_GRID_PRIMARY_WIDTH,
        color: this.BG_GRID_PRIMARY_COLOR,
      };

      const secondary = {
        spacing: secondaryGrid,
        width: this.BG_GRID_SECONDARY_WIDTH,
        color: this.BG_GRID_SECONDARY_COLOR,
      };

      // Draw the primary grid crossses
      for (const { spacing, width, color } of [secondary, primary]) {
        ctx.strokeStyle = color;
        ctx.beginPath();
        for (let x = minX; x <= maxX; x += spacing) {
          ctx.moveTo(x, minY);
          ctx.lineTo(x, maxY);
        }
        for (let y = minY; y <= maxY; y += spacing) {
          ctx.moveTo(minX, y);
          ctx.lineTo(maxX, y);
        }
        ctx.lineWidth = width / zoom;
        ctx.stroke();
        ctx.closePath();
      }

      ctx.restore();
    }
  };
}

export default BackgroundBehaviors;
